module.exports = __webpack_public_path__ + "static/3kids-100x78-3b3c0d2ce12c570b989ac2ae98b1fb65.png";